const getCondition = (conditionContent, state) => {
  const stateList = Object.keys(conditionContent);
  const fallbackState = stateList[stateList.length - 1];
  return conditionContent[`${state}`] ?? conditionContent["fallback"] ?? conditionContent[fallbackState];
};
export {
  getCondition
};
//# sourceMappingURL=getCondition.mjs.map